var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{style:(_vm.blur
      ? 'filter: blur(5px); -webkit-filter: blur(5px);-moz-filter: blur(5px)'
      : ''),attrs:{"min-width":_vm.width,"max-width":_vm.width,"aspect-ratio":2 / 3,"src":_vm.$config.managerMedia + _vm.path,"lazy-src":_vm.$config.managerMedia + _vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }